export default __webpack_public_path__ + "static/media/undraw_map_re_60yf@2x.3c5bd65b.png";